import { render, staticRenderFns } from "./BillingSettingsIcon.vue?vue&type=template&id=ae72afd0&scoped=true"
import script from "./BillingSettingsIcon.vue?vue&type=script&lang=js"
export * from "./BillingSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae72afd0",
  null
  
)

export default component.exports